export const STRINGS = {
  BULLET: '\u2022',
  LINE_BREAK: '\n',
  NBSP: '\u00A0',
  OCTOTHORPE: '#',
  PLUS: '+',
  PIPE: '|',
};
